/* 🤖 this file was generated by svg-to-ts */
export const emperorIconFileAdd21: {
  name: 'file_add_2_1';
  data: string;
} = {
  name: 'file_add_2_1',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0Z"/><g><path d="M18 14.349V4.586L13.414 0H2C.897 0 0 .898 0 2v18c0 1.1.897 2 2 2h12.349c-.23-.63-.35-1.3-.35-2 0-2.62 1.67-4.827 4-5.651Zm-9 .65H3v-2h6v2Zm3-4H3v-2h9v2Zm0-5v-5l5 5h-5Z"/><path d="M21 19l0-3 -2 0 0 3 -3 0 0 2 3 0 0 3 2 0 0-3 3 0 0-2Z"/></g></svg>`,
};
